import { data } from "browserslist";
import API from "../../../../global/api";

//post
export const postData = (data) => {
  return (dispatch) => {
    API.post(`form_msa/add-form-msa-data`, data).then((res) => {
      dispatch(successPostData(data));
    })
  }
}


export const requestPostData = () => {
  return {
    type: "REQUEST_POST_DATA",
  }
}

export const successPostData = (data) => {
  return {
    type: "SUCCESS_POST_DATA",
    payload: data,
  }
}

export const errorPostData = (data) => {
  return {
    type: "ERROR_POST_DATA",
    payload: data,
  }
}

//Case 1
export const petitionerReceice = (data) => {
  return (dispatch) => {
    API.put(`form_msa/divisionProperty`, data).then((res) => {
      dispatch(successputPetitionerReceice(data));
    })
  }
}


export const requestputPetitionerReceice = () => {
  return {
    type: "REQUEST_FORM_MSA_PETITIONER_RECEICE",
  }
}

export const successputPetitionerReceice = (data) => {
  return {
    type: "SUCCESS_FORM_MSA_PETITIONER_RECEICE",
    payload: data,
  }
}

export const errorputPetitionerReceice = (data) => {
  return {
    type: "ERROR_FORM_MSA_PETITIONER_RECEICE",
    payload: data,
  }
}

//Case 2
export const divisionDebts = (data) => {
  return (dispatch) => {
    API.put(`form_msa/divisionDebts`, data).then((res) => {
      dispatch(successputDivisionDebts(data));
    })
  }
}


export const requestputDivisionDebts = () => {
  return {
    type: "REQUEST_FORM_MSA_DIVIOSION_DEBTS",
  }
}

export const successputDivisionDebts = (data) => {
  return {
    type: "SUCCESS_FORM_MSA_DIVIOSION_DEBTS",
    payload: data,
  }
}

export const errorputDivisionDebts = (data) => {
  return {
    type: "ERROR_FORM_MSA_DIVIOSION_DEBTS",
    payload: data,
  }
}

//Case 3
export const equalizationPayment = (data) => {
  return (dispatch) => {
    API.put(`form_msa/equalization`, data).then((res) => {
      dispatch(successputEqualizationPayment(data));
    })
  }
}


export const requestputEqualizationPayment = () => {
  return {
    type: "REQUEST_FORM_MSA_EQUALIZATION_PAYMENT",
  }
}

export const successputEqualizationPayment = (data) => {
  return {
    type: "SUCCESS_FORM_MSA_EQUALIZATION_PAYMENT",
    payload: data,
  }
}

export const errorputEqualizationPayment = (data) => {
  return {
    type: "ERROR_FORM_MSA_EQUALIZATION_PAYMENT",
    payload: data,
  }
}

//Case 4
export const transferRetirement  = (data) => {
  return (dispatch) => {
    API.put(`form_msa/transferRetirementFund`, data).then((res) => {
      dispatch(successputTransferRetirement(data));
      
    })
  }
}
export const requestputTransferRetirement = () => {
  return {
    type: "REQUEST_FORM_MSA_TRANSFER_RETIREMENT",
  }
}

export const successputTransferRetirement = (data) => {
  return {
    type: "SUCCESS_FORM_MSA_TRANSFER_RETIREMENT",
    payload: data,
  }
}

export const errorputTransferRetirement = (data) => {
  return {
    type: "ERROR_FORM_MSA_TRANSFER_RETIREMENT",
    payload: data,
  }
}

//Case 5
export const prentingPlan  = (data) => {
  return (dispatch) => {
    API.put(`form_msa/parentingPlan`, data).then((res) => {
      dispatch(successputPrentingPlan(data));
      
    })
  }
}
export const requestputPrentingPlan = () => {
  return {
    type: "REQUEST_FORM_MSA_PARENTING_PLAN",
  }
}

export const successputPrentingPlan = (data) => {
  return {
    type: "SUCCESS_FORM_MSA_PARENTING_PLAN",
    payload: data,
  }
}

export const errorputPrentingPlan = (data) => {
  return {
    type: "ERROR_FORM_MSA_PARENTING_PLAN",
    payload: data,
  }
}

//Case 6
export const regularSchedule  = (data) => {
  return (dispatch) => {
    API.put(`form_msa/regularSchedule`, data).then((res) => {
      dispatch(successputRegularSchedule(data));
      
    })
  }
}
export const requestputRegularSchedule = () => {
  return {
    type: "REQUEST_FORM_MSA_REGULAR_SCHEDULE",
  }
}

export const successputRegularSchedule = (data) => {
  return {
    type: "SUCCESS_FORM_MSA_REGULAR_SCHEDULE",
    payload: data,
  }
}

export const errorputRegularSchedule = (data) => {
  return {
    type: "ERROR_FORM_MSA_REGULAR_SCHEDULE",
    payload: data,
  }
}

//Case 7
export const holidaySchedule  = (data) => {
  return (dispatch) => {
    API.put(`form_msa/holidaySchedule`, data).then((res) => {
      dispatch(successputHolidaySchedule(data));
      
    })
  }
}

export const requestputHolidaySchedule = () => {
  return {
    type: "REQUEST_FORM_MSA_HOLIDAY_SCHEDULE",
  }
}

export const successputHolidaySchedule = (data) => {
  return {
    type: "SUCCESS_FORM_MSA_HOLIDAY_SCHEDULE",
    payload: data,
  }
}

export const errorputHolidaySchedule = (data) => {
  return {
    type: "ERROR_FORM_MSA_HOLIDAY_SCHEDULE",
    payload: data,
  }
}

//Case 8
export const summerSchedule  = (data) => {
  return (dispatch) => {
    API.put(`form_msa/summerSchedule`, data).then((res) => {
      dispatch(successputSummerSchedule(data));
      
    })
  }
}

export const requestputSummerSchedule = () => {
  return {
    type: "REQUEST_FORM_MSA_SUMMER_SCHEDULE",
  }
}

export const successputSummerSchedule = (data) => {
  return {
    type: "SUCCESS_FORM_MSA_SUMMER_SCHEDULE",
    payload: data,
  }
}

export const errorputSummerSchedule = (data) => {
  return {
    type: "ERROR_FORM_MSA_SUMMER_SCHEDULE",
    payload: data,
  }
}


//Case 10
export const spousalSupport = (data) => {
  return (dispatch) => {
    API.put(`form_msa/spousalSupport`, data).then((res) => {
      dispatch(successputSpousalSupport(data));
    })
  }
}


export const requestputSpousalSupport = () => {
  return {
    type: "REQUEST_FORM_MSA_SPOUSAL_SUPPORT",
  }
}

export const successputSpousalSupport = (data) => {
  return {
    type: "SUCCESS_FORM_MSA_SPOUSAL_SUPPORT",
    payload: data,
  }
}

export const errorputSpousalSupport = (data) => {
  return {
    type: "ERROR_FORM_MSA_SPOUSAL_SUPPORT",
    payload: data,
  }
}

//Get All Data.
export const maritalSettlementGetAllData = (data) => {
  return (dispatch) => {
    dispatch(requestputMaritalSettlementGetAllData());
    API.post(`form_msa/get-all-form-data`, data).then((res) => {
      
      let data1 = res.data.data;
      dispatch(successputMaritalSettlementGetAllData(data1));
    }).catch((error)=> 
    dispatch(errorputMaritalSettlementGetAllData()));
  };
};

export const requestputMaritalSettlementGetAllData = () => {
  return {
    type: "REQUEST_MSA_MARITAL_SETTLEMENT_GET_ALL_DATA",
  };
};
export const successputMaritalSettlementGetAllData = (data) => {
  return {
    type: "SUCCESS_MSA_MARITAL_SETTLEMENT_GET_ALL_DATA",
    payload: data,
  };
};
export const errorputMaritalSettlementGetAllData = () => {
  return {
    type: "ERROR_MSA_MARITAL_SETTLEMENT_GET_ALL_DATA",
  };
};
